<template lang="pug">
    div
        label.switch
            input(type="checkbox" :checked="value" @input="$emit('input', $event.target.checked)" :disabled="disabled")
            span.slider.round
</template>

<script>
export default {
    name: "settings-switcher",

    props: {
        value: Boolean,
        disabled: Boolean,
    },
}
</script>
